export default __webpack_public_path__ + "static/media/dashboard-white.58166ce0.svg";